"use client";

// Single mount point for the command-bar surface. The app layout
// renders <CommandBarMount /> once at the root; this composes the
// context provider, hotkey binder, palette, and panel host so
// pages don't need to think about ordering.
import * as React from "react";
import { CommandContextProvider } from "@/lib/commands/context";
import { CommandBar } from "@/components/command-bar/command-bar";
import { CommandHotkeys } from "@/components/command-bar/hotkeys";
import { CommandPanelHost } from "@/components/command-bar/panel-host";
import { installTelemetryFlush } from "@/lib/commands/telemetry";

export function CommandBarMount() {
  React.useEffect(() => {
    installTelemetryFlush();
  }, []);
  return (
    <CommandContextProvider>
      <CommandBar />
      <CommandHotkeys />
      <CommandPanelHost />
    </CommandContextProvider>
  );
}

export { CommandContextMenu } from "@/components/command-bar/command-context-menu";
